import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _get from "lodash/get";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.map.js";
import React from 'react';
import classNames from 'classnames';
import Image from '@nerdwallet/react-image';
import { colors } from '@nerdwallet/base-styles/variables';
import classes from '@nerdwallet/base-styles/classes';
import Close from '@nerdwallet/react-icon/material/Close';
import analyticsLib from '@nerdwallet/analytics';
import { TrkElement } from '@nerdwallet/nw-client-lib/trk-helper';
import MarketplaceApplyNow, { APPLY_NOW_LINK_TYPES, LINK_TYPES } from '@nerdwallet/react-marketplace-apply-now';
import Chiclet from '@nerdwallet/react-chiclet';
import { Impression, ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { CCProductImpression, ProductImpression } from '@nerdwallet/nw-client-lib/tracking';
import { getApplyLink, getInstitutionId, getIsMonetizing, getIssuerName, getOfferId, getProductId, getProductType, getSlug } from '@nerdwallet/marketplace/selectors/common';
import { PRODUCT_TYPES } from '@nerdwallet/marketplace/constants';
import { Text } from '@nerdwallet/currency';
import ApplyNow from '@nerdwallet/react-apply-now';
import { EVENT_TYPES, ENTITY_NAME, ACTION, INTERACTION_TYPE, MONETIZING, buildAnalyticsEntityName } from '../../lib/analytics-constants';
import { buildTrkSectionCategory } from '../../utils';
import styles from '../comparison-grid.module.less'; // TODO: Extract styles for this component into its own .module.less file.

import { getUniqueEntityId } from '../../lib/product-constants';

/**
 * Column Header with the entity image, close button and product name
 */
export var ColumnHeader = function ColumnHeader(_ref) {
  var _entity$marketplaceEn, _entity$marketplaceEn2, _entity$marketplaceEn3, _entity$drivers, _entity$drivers$find;

  var canRemove = _ref.canRemove,
      entity = _ref.entity,
      className = _ref.className,
      removeEntityClickHandler = _ref.removeEntityClickHandler,
      showGradient = _ref.showGradient,
      tabName = _ref.tabName,
      tabPosition = _ref.tabPosition,
      taxonomy = _ref.taxonomy,
      paginationItemIndex = _ref.paginationItemIndex,
      entityItemOverallPosition = _ref.entityItemOverallPosition,
      updatePaginationItemIndex = _ref.updatePaginationItemIndex,
      showMobileStickyColumnHeader = _ref.showMobileStickyColumnHeader,
      renderStickyBanner = _ref.renderStickyBanner,
      classesProp = _ref.classes;
  var TRK_PRODUCT_LOCATION = 'ComparisonGrid';
  var entityLegacyId = entity === null || entity === void 0 ? void 0 : (_entity$marketplaceEn = entity.marketplaceEntity) === null || _entity$marketplaceEn === void 0 ? void 0 : (_entity$marketplaceEn2 = _entity$marketplaceEn.details) === null || _entity$marketplaceEn2 === void 0 ? void 0 : (_entity$marketplaceEn3 = _entity$marketplaceEn2.legacy_id) === null || _entity$marketplaceEn3 === void 0 ? void 0 : _entity$marketplaceEn3.value;
  var entityMarketplaceId = getProductId(entity === null || entity === void 0 ? void 0 : entity.marketplaceEntity);
  var productType = getProductType(entity === null || entity === void 0 ? void 0 : entity.marketplaceEntity);

  var imageIsPortrait = _get(entity, 'marketplaceEntity.details.image_is_portrait.value', false);

  var internalRemoveEntityClickHandler = function internalRemoveEntityClickHandler(impressionId) {
    analyticsLib.track(EVENT_TYPES.ELEMENT_INTERACTED, {
      action: ACTION.SELECT,
      entity_name: ENTITY_NAME.COMPARISON_GRID_REMOVE_ENTITY,
      element_name: ENTITY_NAME.COMPARISON_GRID_REMOVE_ENTITY,
      interaction_type: INTERACTION_TYPE.PRESS,
      impression_id: impressionId
    }); // as we are moving forward from storing entities in redux, we will store offer.id instead of legacy_id

    var uniqueId = getUniqueEntityId(entity === null || entity === void 0 ? void 0 : entity.marketplaceEntity, productType);
    removeEntityClickHandler(uniqueId); // eslint-disable-next-line @typescript-eslint/no-unused-expressions

    paginationItemIndex === 0 ? updatePaginationItemIndex(0) : updatePaginationItemIndex(paginationItemIndex - 1);
  }; // display close button to remove entity from the compare list


  var closeButton = /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (impressionContext) {
    return canRemove && /*#__PURE__*/React.createElement("button", {
      type: "button",
      "aria-label": "Close",
      className: classNames([styles.entityHeader__removeIcon], classesProp === null || classesProp === void 0 ? void 0 : classesProp.remove),
      onClick: function onClick() {
        return internalRemoveEntityClickHandler(impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId);
      }
    }, /*#__PURE__*/React.createElement(Close, {
      size: 24
    }));
  });
  var productImpressionPayload = {
    destination_url: getApplyLink(entity === null || entity === void 0 ? void 0 : entity.marketplaceEntity),
    element_position: entityItemOverallPosition,
    marketplace_institution_id: getInstitutionId(entity === null || entity === void 0 ? void 0 : entity.marketplaceEntity),
    marketplace_offer_id: getOfferId(entity === null || entity === void 0 ? void 0 : entity.marketplaceEntity),
    marketplace_product_id: entityMarketplaceId,
    marketplace_product_type: getProductType(entity === null || entity === void 0 ? void 0 : entity.marketplaceEntity),
    monetizable: getIsMonetizing(entity === null || entity === void 0 ? void 0 : entity.marketplaceEntity) ? MONETIZING.YES_ASSUMED : MONETIZING.NO,
    section_name: tabName,
    section_position: tabPosition
  };

  var plpqProductImpressionPayload = _objectSpread(_objectSpread({}, productImpressionPayload), {}, {
    element_name: renderStickyBanner ? ENTITY_NAME.PREQUAL_OFFER_PRODUCT_IMPRESSION : ENTITY_NAME.SHOPPING_PRODUCT_ENTITY,
    page_number: null
  });

  var entityImage = /*#__PURE__*/React.createElement(Image, _extends({
    src: _get(entity, 'imageInfo.src'),
    alt: _get(entity, 'imageInfo.altText'),
    backgroundColor: colors.transparent,
    naturalHeight: _get(entity, 'imageInfo.height'),
    naturalWidth: _get(entity, 'imageInfo.width')
  }, entity.imageInfo));
  var secondaryCtasEntityName = buildAnalyticsEntityName("".concat(ENTITY_NAME.SECONDARY_CTA, "_").concat(entity.secondaryCtaText));
  var secondaryCtas = entity.secondaryCtaText && entity.secondaryCtaHref && /*#__PURE__*/React.createElement(Impression, {
    className: styles.secondaryCta,
    entityName: secondaryCtasEntityName,
    eventType: EVENT_TYPES.ELEMENT_IMPRESSION
  }, /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (impressionContext) {
    return /*#__PURE__*/React.createElement(MarketplaceApplyNow, {
      className: classNames(styles.secondaryCta__link, classesProp === null || classesProp === void 0 ? void 0 : classesProp.ratesFees),
      impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
      elementPosition: entityItemOverallPosition,
      marketplaceEntity: entity.marketplaceEntity,
      id: APPLY_NOW_LINK_TYPES.ratesAndFeesText,
      link: entity.secondaryCtaHref,
      linkType: APPLY_NOW_LINK_TYPES.ratesAndFeesText,
      sectionName: productImpressionPayload === null || productImpressionPayload === void 0 ? void 0 : productImpressionPayload.section_name,
      sectionPosition: entityItemOverallPosition,
      type: LINK_TYPES.LINK // // BNK specific props
      ,
      displayPage: "displayPage",
      disableBankCtaAnnotation: true,
      shouldLogImpression: false,
      primary: false,
      showIcon: false
    }, entity.secondaryCtaText);
  })); // wraps the entityImage and entityName with MarketplaceApplyNow
  // so the entities are clickable with all the required tracking params

  var getMarketPlaceApplyWrapper = function getMarketPlaceApplyWrapper() {
    return /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (_ref2) {
      var impressionId = _ref2.impressionId;
      return entity.applyNow ? /*#__PURE__*/React.createElement(ApplyNow, _extends({
        impressionId: impressionId
      }, entity.applyNow)) : /*#__PURE__*/React.createElement(MarketplaceApplyNow, {
        impressionId: impressionId,
        elementPosition: entityItemOverallPosition,
        marketplaceEntity: entity.marketplaceEntity,
        id: "".concat(TRK_PRODUCT_LOCATION, "__product-image--").concat(entityItemOverallPosition),
        link: entity.ctaHref,
        linkType: renderStickyBanner ? APPLY_NOW_LINK_TYPES.ratesAndFeesText : APPLY_NOW_LINK_TYPES.applyNowButton,
        productLocation: TRK_PRODUCT_LOCATION,
        productPosition: entityItemOverallPosition,
        trkElement: TrkElement.image,
        trkPageType: entity.trkPageType,
        trkSectionCategory: buildTrkSectionCategory(entity.trkSectionCategory, 'entityImage'),
        trkTaxonomy: taxonomy,
        type: LINK_TYPES.BUTTON // // BNK specific props
        ,
        displayPage: "displayPage",
        disableBankCtaAnnotation: true,
        shouldLogImpression: false,
        primary: false,
        showIcon: false,
        className: classesProp === null || classesProp === void 0 ? void 0 : classesProp.applyNow
      });
    });
  };

  var entityImageClassName = classNames(styles.entityImageDimension, styles["entityImageDimension--".concat(productType)], // For any product-type specific overrides.
  _defineProperty({}, styles["entityImageDimension--cc_image_portrait"], imageIsPortrait), // For any CC with image portrait
  classesProp === null || classesProp === void 0 ? void 0 : classesProp.image);
  var commonImpressionProps = {
    productSlug: getSlug(entity === null || entity === void 0 ? void 0 : entity.marketplaceEntity),
    productLocation: tabName,
    monetizing: getIsMonetizing(entity === null || entity === void 0 ? void 0 : entity.marketplaceEntity),
    productInstance: "comparison_grid_".concat(ENTITY_NAME.SHOPPING_PRODUCT_ENTITY),
    productPosition: entityItemOverallPosition,
    sectionPosition: tabPosition,
    issuer: getIssuerName(entity === null || entity === void 0 ? void 0 : entity.marketplaceEntity),
    category: productType
  }; // https://github.com/NerdWallet/nw-client-lib/blob/master/src/tracking/components/product-impression.jsx

  var ProductImpressionProps = _objectSpread(_objectSpread({}, commonImpressionProps), {}, {
    id: "comparison_grid_search-".concat(tabName, "-").concat(entityMarketplaceId),
    productId: "".concat(entityMarketplaceId),
    vertical: productType
  }); // https://github.com/NerdWallet/nw-client-lib/blob/master/src/tracking/components/cc-product-impression.jsx


  var CCProductImpressionProps = _objectSpread(_objectSpread({}, commonImpressionProps), {}, {
    id: "comparison_grid_search-".concat(tabName, "-").concat(entityLegacyId),
    productId: "".concat(entityLegacyId)
  });

  var renderChiclet = function renderChiclet(_ref3) {
    var text = _ref3.text,
        color = _ref3.color;
    return /*#__PURE__*/React.createElement("div", {
      className: classes('margin-top-2', 'margin-bottom-2')
    }, /*#__PURE__*/React.createElement(Chiclet, {
      text: text,
      color: color
    }));
  };

  var chicletDataList = entity === null || entity === void 0 ? void 0 : (_entity$drivers = entity.drivers) === null || _entity$drivers === void 0 ? void 0 : (_entity$drivers$find = _entity$drivers.find(function (driver) {
    return driver.id === 'chiclet';
  })) === null || _entity$drivers$find === void 0 ? void 0 : _entity$drivers$find.chicletDataList;

  var ProductImpressionWrapper = function ProductImpressionWrapper(_ref4) {
    var children = _ref4.children;

    if (productType === PRODUCT_TYPES.CREDIT_CARDS) {
      return /*#__PURE__*/React.createElement(CCProductImpression, CCProductImpressionProps, children);
    }

    return /*#__PURE__*/React.createElement(ProductImpression, ProductImpressionProps, children);
  };

  return /*#__PURE__*/React.createElement(Impression, {
    key: entity.id,
    className: classNames([className, showGradient && styles.cellGradient, styles.columnHeaderMargins]),
    component: "th",
    eventType: EVENT_TYPES.PRODUCT_IMPRESSION,
    entityName: renderStickyBanner ? ENTITY_NAME.PREQUAL_OFFER_PRODUCT_IMPRESSION : ENTITY_NAME.SHOPPING_PRODUCT_ENTITY,
    payload: renderStickyBanner ? plpqProductImpressionPayload : productImpressionPayload
  }, /*#__PURE__*/React.createElement(ProductImpressionWrapper, null, /*#__PURE__*/React.createElement("div", {
    className: styles.columnHeaderContent
  }, closeButton, /*#__PURE__*/React.createElement("div", {
    className: entityImageClassName
  }, entityImage), !showMobileStickyColumnHeader && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.entityName__title, classesProp === null || classesProp === void 0 ? void 0 : classesProp.title) // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: entity.productName
    }
  })), secondaryCtas), chicletDataList && chicletDataList.length > 0 && chicletDataList.map(function (chiclet) {
    return renderChiclet(chiclet);
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames(_defineProperty({}, styles.entityHeader__mobileStickyMargin, showMobileStickyColumnHeader))
  }, getMarketPlaceApplyWrapper()))));
};